import React from "react";
import { createRoot } from "react-dom/client";

// App components for each site type
import OripaApp from "../pages/customer/oripa/App";
import KujiApp from "../pages/customer/kuji/App";
import { captureInitialAdvertisingAttribution } from "../utils/advertisingAttribution";

import '../index.css'

const rootElement = document.getElementById("react-root");

if (rootElement) {
  captureInitialAdvertisingAttribution();

  // data-site属性からサイト情報を取得
  const siteDataString = rootElement.getAttribute('data-site');
  const siteData = siteDataString ? JSON.parse(siteDataString) : undefined;

  const root = createRoot(rootElement);

  // site_type に基づいて適切な App を選択
  const siteType = siteData?.site_type || 'oripa';

  if (siteType === 'kuji') {
    root.render(<KujiApp siteData={siteData} />);
  } else {
    root.render(<OripaApp siteData={siteData} />);
  }
}
